(function(){
  function init(root){
    var main=root.querySelector('.gs-main-img');
    root.querySelectorAll('[data-gs-thumb]').forEach(function(b){
      b.addEventListener('click',function(){
        if(main){main.removeAttribute('srcset');main.src=b.getAttribute('data-src');main.alt=b.getAttribute('data-alt')||'';}
        root.querySelectorAll('[data-gs-thumb]').forEach(function(x){x.classList.remove('is-active');});
        b.classList.add('is-active');
      });
    });
    root.querySelectorAll('[data-gs-qty]').forEach(function(q){
      var inp=q.querySelector('input');
      q.querySelectorAll('[data-step]').forEach(function(b){
        b.addEventListener('click',function(){
          var n=(parseInt(inp.value,10)||1)+parseInt(b.getAttribute('data-step'),10);
          inp.value=Math.min(10,Math.max(1,n));
        });
      });
    });
    var sel=root.querySelector('[data-gs-variant]');
    if(sel){
      sel.addEventListener('change',function(){
        var o=sel.options[sel.selectedIndex];if(!o)return;
        if(o.dataset.price){root.querySelectorAll('[data-gs-price]').forEach(function(el){el.textContent=o.dataset.price;});}
        if(main&&o.dataset.image){main.removeAttribute('srcset');main.src=o.dataset.image;}
      });
    }
    var sticky=root.querySelector('[data-gs-sticky]'),cta=root.querySelector('[data-gs-cta]');
    if(sticky&&cta){
      var f=function(){var r=cta.getBoundingClientRect();var show=r.bottom<0||r.top>window.innerHeight;sticky.classList.toggle('is-on',show);sticky.setAttribute('aria-hidden',show?'false':'true');sticky.inert=!show;};
      window.addEventListener('scroll',f,{passive:true});window.addEventListener('resize',f);f();
    }
  }
  function boot(){document.querySelectorAll('[data-gs-root]').forEach(init);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
